var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FFF9E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9916 15.2098C20.8991 15.2098 18.3911 17.7166 18.3911 20.8103C18.3911 23.904 20.8979 26.4109 23.9916 26.4109C27.0841 26.4109 29.5921 23.904 29.5921 20.8103C29.5885 17.719 27.0829 15.2146 23.9928 15.2098H23.9916ZM23.9916 23.2104C22.6656 23.2104 21.5915 22.1364 21.5915 20.8103C21.5915 19.4843 22.6656 18.4103 23.9916 18.4103C25.3176 18.4103 26.3917 19.4843 26.3917 20.8103C26.3905 22.1352 25.3164 23.2092 23.9916 23.2104V23.2104ZM24 8C15.163 8 8 15.1642 8 24C8 32.8358 15.1642 40 24 40C32.837 40 40 32.8358 40 24C39.9892 15.1678 32.8322 8.0096 24.0012 8H24V8ZM17.8942 35.2491C18.0251 35.1315 18.1343 34.9947 18.2195 34.8423L18.2231 34.8339C19.3199 32.723 21.4907 31.3058 23.9916 31.3058C26.5021 31.3058 28.6789 32.7338 29.7553 34.8219L29.7721 34.8579C29.8549 35.0139 29.9557 35.1483 30.0758 35.2635C28.3189 36.2319 26.2249 36.8019 23.9976 36.8019C21.7595 36.8019 19.6559 36.2271 17.827 35.2155L17.893 35.2491H17.8942ZM32.6318 33.425L32.627 33.407C30.9938 30.2366 27.7417 28.1053 23.9928 28.1053C20.2571 28.1053 17.0146 30.221 15.4006 33.3206L15.3754 33.3746C15.3682 33.389 15.3694 33.4058 15.3622 33.4202C12.8001 31.0718 11.1993 27.7093 11.1993 23.9736C11.1993 16.9042 16.9306 11.1729 24 11.1729C31.0694 11.1729 36.8007 16.9042 36.8007 23.9736C36.8007 27.7129 35.1975 31.0766 32.6414 33.4166L32.6318 33.425V33.425Z",
    fill: "#CFA809"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePic);
export default __webpack_public_path__ + "static/media/profile-pic.45c92c8d1f5066a7b6907f501bddf776.svg";
export { ForwardRef as ReactComponent };